import { useState } from "react";
import { Get, Set } from "../../../../../../Request";
import { useDispatch, useSelector } from "react-redux";
import {
  compaireTwoDate,
  ToDateJalali,
  RenderPrice,
  addTime,
} from "../../../../../Common/Function/index";
import moment from "jalali-moment";
import { useParams } from "react-router";

export const useTableWeek = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { user_type, user, basket } = useSelector(state => state);
  const [week, setWeek] = useState({
    week:
      user.itemtype == "sans" && user.itemtype == "sanswcount" ? true : false,
  });
  const [days, setDays] = useState();
  const [loadingWeek, setLoadingWeek] = useState(true);
  const [loadingSans, setLoadingSans] = useState(false);
  const [modal, setModal] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState();
  const [list, setList] = useState();
  const [loading, setloading] = useState(true);
  const getWeek = data => {
    setLoadingWeek(true);
    Get({
      url: "/timetable/sans_weektable",
      data: { item_id: slug, ...data },
    }).then(res => {
      setWeek(res);
      setDays([
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ]);
      setLoadingWeek(false);
    });
  };
  const convertDay = day => {
    switch (day) {
      case "Wednesday":
        return "چهارشنبه";
      case "Thursday":
        return "پنج شنبه";
      case "Friday":
        return "جمعه";
      case "Monday":
        return "دوشنبه";
      case "Tuesday":
        return "سه شنبه";
      case "Saturday":
        return "شنبه";
      case "Sunday":
        return "یک شنبه";
      default:
        break;
    }
  };
  const checkSecondPrice = data => {
    return data.second_price;
  };
  const statusHandler = (data, day) => {
    let result = {};
    let stat = data && data.status.split("-");
    if (
      compaireTwoDate(day, moment().format("YYYY-MM-DD"), data && data.time) &&
      compaireTwoDate(day, moment().format("YYYY-MM-DD"), data && data.time) !=
        "today"
    ) {
      if (stat[0] === "R" && stat[1] != "m") {
        result = {
          style: {
            background: "#E42A3F ",
            color: "white",
            padding: "14px",
            borderStyle: "dashed",
            borderColor: "#dddddd",
            borderWidth: 1,
            cursor: "pointer",
            fontWeight: "200",
          },
          text: "مشاهده رزرو",
          status: "reserve",
        };
      } else {
        result = {
          text: "گذشته ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            padding: "14px",
            fontWeight: "200",
            cursor: "not-allowed",
          },
          status: false,
        };
      }
    } else {
      if (data && data.status) {
        if (stat[0] === "R") {
          if (stat[1] === "m") {
            result = {
              style: {
                background: "#E42A3F ",
                color: "white",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,

                fontWeight: "200",
                color: "#fff",
              },
              text: "رزرو توسط مدیر",
              status: true,
              cancel: true,
            };
          } else {
            result = {
              style: {
                background: "#E42A3F ",
                color: "white",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              text: "مشاهده رزرو",
              status: "reserve",
            };
          }
        } else if (stat[0] === "S" && stat[1] === "g") {
          if (user_type === null && stat[2] == (user && user.id)) {
            result = {
              style: {
                background: "#CBFF98",
                fontWeight: "200",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              text: "در حال رزرو",
              status: true,
            };
          } else {
            result = {
              style: {
                background: "#FFF198",
                padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                fontWeight: "200",
              },
              text: "در حال رزرو",

              status: "another",
            };
          }
        } else {
          if (stat[0] === "S" && stat[1] === "u") {
            if (
              (user_type === "user" ||
                user_type === "manager" ||
                user_type === "coach") &&
              stat[2] == (user && user.id)
            ) {
              result = {
                style: {
                  background: "#CBFF98",
                  fontWeight: "200",
                  padding: "14px",
                  borderStyle: "dashed",
                  borderColor: "#dddddd",
                  borderWidth: 1,
                  cursor: "pointer",
                  fontWeight: "200",
                },
                text: "در حال رزرو",
                status: true,
              };
            } else {
              result = {
                style: {
                  background: "#FFF198",
                  fontWeight: "200",
                  padding: "14px",
                  borderStyle: "dashed",
                  borderColor: "#dddddd",
                  borderWidth: 1,

                  fontWeight: "200",
                },
                text: "در حال رزرو",
                status: "another",
              };
            }
          }
        }
        if (stat == "ready") {
          result = {
            style: {
              background: "#DDFFE8",
              color: "#05974d",
              padding: "14px",
              borderStyle: "dashed",
              borderColor: "#dddddd",
              borderWidth: 1,
              cursor: "pointer",
              fontWeight: "200",
            },
            text: RenderPrice(data),
            status: checkSecondPrice(data) ? "second_price" : true,
          };
        } else if (stat == "future") {
          result = {
            text: "بدون قرارداد ",
            style: {
              backgroundColor: "#fafafa",
              color: "#ccc",
              padding: "14px",
              fontWeight: "200",
              cursor: "not-allowed",
            },
            status: false,
          };
        } else if (stat == "last") {
          result = {
            text: "گذشته ",
            style: {
              backgroundColor: "#fafafa",
              color: "#ccc",
              padding: "14px",
              fontWeight: "200",
              cursor: "not-allowed",
            },
            status: false,
          };
        }
      } else {
        result = {
          text: "گذشته ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            padding: "14px",
            fontWeight: "200",
            cursor: "not-allowed",
          },
        };
      }
    }

    return result;
  };
  const checkTime = () => {};
  const getDate = (date, week, jalali) => {
    if (week && date) {
      if (jalali) {
        return week.data[date].date;
      }
      return `${ToDateJalali(week.data[date].date).split("/")[1]}/${
        ToDateJalali(week.data[date].date).split("/")[2]
      }`;
    }
  };
  const getYear = (date, week) => {
    if (date && week) {
      return `${ToDateJalali(week.data[date].date).split("/")[0]}`;
    }
  };
  const checkCurrentWeek = data => {
    let result = false;
    if (data) {
      days.map(day => {
        if (data.data[day].date == new Date().toISOString().split("T")[0]) {
          result = true;
        }
      });
    }

    return result;
  };

  const changeStatus = async (data, item, day, currentDay) => {
    if (statusHandler(data, day)["cancel"]) {
      // cancelByManager({ sans_id: data.id, day: data.day_id })
      setModal({
        data: data,
        day: day,
        currentDay,
        status: "cancel",
      });
    } else if (statusHandler(data, day)["another"]) {
      setModal({
        data: data,
        day: day,
        currentDay,
        status: "another",
      });
    } else {
      setModal({
        data: data,
        day: day,
        currentDay,
      });
    }
  };
  const reserveByManager = async data => {
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/new_contract_admin",
      data: { item_id: slug, ...data },
    }).then(() => {
      // selectDay(form.day_details);
      setLoadingBtn(false);
    });
  };
  const cancelByManager = async data => {
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/cansel_contract_admin",
      data: { item_id: slug, ...data },
    }).then(() => {
      // selectDay(form.day_details);
      getWeek();
      setLoadingBtn(false);
    });
  };
  const updateTimeTable = async data => {
    // setLoading({ ...loading, all: true, btnLoading: true });
    setLoadingBtn(data.sans_id);
    await Set({
      url: "/item/update_timetable",
      data: { item_id: slug, ...data },
    }).then(() => {
      // setLoading({ ...loading, all: true, btnLoading: false });
      // selectDay(form.day_details);
      setLoadingBtn(false);
      setModal(false);
    });
  };

  const showReserve = async data => {
    setloading(true);
    await Get({
      url: "/reserve/get_sans_reserve",
      data: { item_id: slug, ...data },
    }).then(response => {
      setList(response);
      setloading(false);
    });
  };

  return {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    statusHandler,
    getDate,
    changeStatus,
    loadingSans,
    checkCurrentWeek,
    getYear,
    modal,
    setModal,
    reserveByManager,
    cancelByManager,
    updateTimeTable,
    loadingBtn,
    showReserve,
    list,
    setList,
    loading,
  };
};
